import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'tidy-bookable-legend',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './bookable-legend.component.html',
    styleUrls: ['./bookable-legend.component.scss'],
    standalone: false
})
export class BookableLegendComponent {

  @Input() public labelOn = 'Bookable';
  @Input() public labelOff = 'Not Bookable';

}
